
import { Options, Vue } from 'vue-class-component';
import mapConfig from "@/config/map";
import RegionService from "@/services/RegionService";
import { OptionalDistanceRegionMinimal } from "@/data/region";
import RegionListEntry from "@/components/RegionListEntry.vue";

@Options({
    props: {
        regions: {
            type: Array,
            required: true,
        }
    },
    components: {
        RegionListEntry,
    },
})
export default class RegionSelectList extends Vue {
    regions!: OptionalDistanceRegionMinimal[]

    /*loadRegions() {
        this.loading = true;
        return RegionService.getList().then(result => {
            this.regions = result.data.data || [];
        }).finally(() => this.loading = false);
    }*/

    // mounted() {}
}
